// Deriva el tipo de intermediario (Broker/Sponsor/Fuerza de Ventas/SDP) y la
// entidad asociada a partir del campo intermediary de invite/user.
// Mismo vocabulario usado en el modal "Invitar usuario" (users.js).
export function getIntermediaryInfo(intermediary) {
  if (intermediary?.broker && typeof intermediary.broker === "object") {
    return { tipo: "Broker", entidad: intermediary.broker.astr_nombre_asesor || "-", detalle: intermediary.broker };
  }
  if (intermediary?.sponsor && typeof intermediary.sponsor === "object") {
    return { tipo: "Sponsor", entidad: intermediary.sponsor.astr_nombre_asesor || "-", detalle: intermediary.sponsor };
  }
  if (intermediary?.fv && typeof intermediary.fv === "object") {
    return { tipo: "Fuerza de Ventas", entidad: intermediary.fv.astr_nombre_asesor || "-", detalle: intermediary.fv };
  }
  if (intermediary?.sdp && typeof intermediary.sdp === "object") {
    return { tipo: "SDP", entidad: intermediary.sdp.astr_nombre_asesor || "-", detalle: intermediary.sdp };
  }
  return { tipo: "-", entidad: "-", detalle: null };
}
